export default "__VITE_ASSET__DhsHgglE__"